module.exports = __webpack_public_path__ + "static/img/mobileBgPic.b624f29.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/IsraelToday/mobileBgPic.png
// module id = ypkJ
// module chunks = 0